type PropTypes = {
  className?: string
}

const BrandIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 7"
      className={className}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M.023 3.563 3.045 6.77l5.524-5.7L7.605.055l-4.546 4.69L1 2.555.023 3.563Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default BrandIcon
